module.exports = __webpack_public_path__ + "static/media/uploadReturnOrderNavigation.c3b0e8a1.png";